// What the cabinet holds while it is open: the chosen language, the languages on offer, and who is signed in.

export interface Locale {
    id: string;
    name: string;
    originalFullName?: string;
    fullName?: string;
    isDefault?: boolean;
}

/** PersonViewModel of the signed-in influencer, once read. */
export interface Person {
    name?: string;
    surname?: string;
    email?: string;
}

export const state: { locale: string | null; locales: Locale[]; person: Person | null } = {
    /** The language every call to the API goes out in (Accept-Language) and the page is shown in. */
    locale: null,
    locales: [],
    person: null
};

const events = new EventTarget();

export type StateEvent = 'languageChanged' | 'localesChanged' | 'personChanged' | 'authChanged' | 'legalBlocked';

export function emit(name: StateEvent, detail?: unknown): void {
    events.dispatchEvent(new CustomEvent(name, { detail }));
}

/** Subscribes, and returns the unsubscribe. */
export function on(name: StateEvent, listener: (event: Event) => void): () => void {
    events.addEventListener(name, listener);

    return () => events.removeEventListener(name, listener);
}
